import React from "react";
import { KatIcon } from "@amzn/katal-react";
import { useTranslation } from "react-i18next";
import { TestStatus } from "src/api/interfaces/nest";
import "./index.css";

const statusConfig = {
  [TestStatus.PASS]: {
    type: "checkmark-circle-fill" as const,
    label: "nest_status_pass",
    variant: "success",
  },
  [TestStatus.FAIL]: {
    type: "x-circle-fill" as const,
    label: "nest_status_fail",
    variant: "error",
  },
  [TestStatus.NO_DATA]: {
    type: "brightness_one" as const,
    label: "nest_status_no_data",
    variant: "secondary",
  },
};

interface NestStatusBadgeProps extends React.HTMLAttributes<HTMLDivElement> {
  status: TestStatus;
  size?: KatIcon.Size;
}

export function NestStatusBadge({
  status,
  size,
  className,
  onClick,
}: NestStatusBadgeProps) {
  const { t } = useTranslation();
  const config = statusConfig[status] ?? statusConfig[TestStatus.NO_DATA];

  return (
    <div
      className={`nest-status-badge nest-status-badge--${config.variant}${className ? ` ${className}` : ""}`}
      onClick={onClick}
    >
      <KatIcon name={config.type} size={size ?? "xsmall"} />
      {t(config.label)}
    </div>
  );
}
